/* eslint-disable import/first */
import React, { useState, useRef, useEffect } from 'react';
import Redux from 'spwa-ui-library/esm/redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight';
import { selectDesktop } from 'spwa-ui-library/esm/redux/store/appSlice';
import css from './index.module.scss';
import ClassNames from 'classnames';
const Accordion = ({ title, desc }) => {
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0');
  const isDesktop = Redux.useSelector(selectDesktop);

  const content = useRef(null);

  const toggleAccordion = () => {
    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(setActive === 'active' ? '0' : `${content?.current?.scrollHeight}rem`);
  };
  useEffect(() => {
    if (isDesktop && setActive !== 'active') {
      setActiveState('active');
      setHeightState(`${content.current.scrollHeight}rem`);
    }
  }, [isDesktop, setActive]);

  return (
    <Grid className={css.root}>
      <Grid
        className={ClassNames(css.header, setActive === 'active' ? css.activeHeader : '')}
        onClick={toggleAccordion}
      >
        <Typography className={css.headerText}>{title}</Typography>
        <Grid className={css.icon}>
          {!isDesktop ? (
            <FiArrowRight
              className={setActive === 'active' ? css.accordion__icon_rotate : css.accordion__icon}
            />
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      <Grid ref={content} style={{ maxHeight: `${setHeight}` }} className={css.accordion__content}>
        <Grid className={css.divider}>
          <Divider />
        </Grid>
        <Grid className={css.accordion__text}>
          <Typography dangerouslySetInnerHTML={{ __html: desc }}></Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Accordion;
